module.exports = __webpack_public_path__ + "img/featur_4.0d4be065.jpg";